/**
 * Detects whether the app is running inside an iframe (e.g. the preview
 * panel). Accessing window.top from a cross-origin frame throws — and the
 * throw itself means "definitely embedded".
 */
export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
